import type { DeepString } from "@/lib/i18n";

/**
 * CNews — polskie tłumaczenia (Aktualności — lista + artykuł).
 *
 * `months[]` — nazwy miesięcy w dopełniaczu (formatPolishDate: "13 maja 2026").
 * `formatDate(date)` — pełny format daty per locale; w PL dopełniacz, w EN
 * "13 May 2026", w DE "13. Mai 2026".
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak aktualności do wyświetlenia.",
  readMore: "Czytaj więcej ->",
  backToList: "<- Wróć do listy",
  paginationAria: "Paginacja",
  /** `formatDate("2026-05-13")` -> "13 maja 2026". */
  formatDate: (iso: string): string => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return iso;
    const months = [
      "stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca",
      "lipca", "sierpnia", "września", "października", "listopada", "grudnia",
    ];
    const month = parseInt(m[2], 10) - 1;
    if (month < 0 || month > 11) return iso;
    return `${parseInt(m[3], 10)} ${months[month]} ${m[1]}`;
  },
  /** `paginationLabel(2, 7)` -> "Strona 2 z 7". */
  paginationLabel: (page: number, totalPages: number) =>
    `Strona ${page} z ${totalPages}`,
  paginationHint: "Paginacja zostanie podłączona w kolejnej iteracji",
} as const;

export type CNewsTranslations = DeepString<typeof pl>;
